<template>
  <FlexRow align="center">
    <SwitchField
        name="コンペ上位者"
        :value="value"
        hide-details
        class="mt-0 pt-0"
        @input="handleInput"
    />
    <InfoIcon
        message="コンペ上位の成績を収めた証である、メダルを獲得したユーザーを選抜して表示します。授与の基準はコンペにより異なりますが、最上位から金・銀・銅の色となります"
        color="#bbb"
    />
  </FlexRow>
</template>

<script>
import SwitchField from "@/components/atoms/SwitchField";
import InfoIcon from "../atoms/InfoIcon";
import FlexRow from "../atoms/FlexRow";
export default {
  name: "ApplicantSearchCompetitionSelect",
  components: {FlexRow, InfoIcon, SwitchField},
  props: {
    value: {
      type: Boolean
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>

</style>